module.exports = __webpack_public_path__ + "overview-a5b6df21/503-4047d3143a02e6fe213c64b20551cbdf.svg";